import { render, staticRenderFns } from "./OnlineTransactions.vue?vue&type=template&id=b152162c&scoped=true&"
import script from "./OnlineTransactions.vue?vue&type=script&lang=ts&"
export * from "./OnlineTransactions.vue?vue&type=script&lang=ts&"
import style0 from "./OnlineTransactions.vue?vue&type=style&index=0&id=b152162c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b152162c",
  null
  
)

export default component.exports